import React, { useEffect, useState, useMemo } from 'react';
import { Line, defaults } from 'react-chartjs-2';
import Button from '@material-ui/core/Button';

defaults.font.family = 'dana';

const Chart = (props) => {

    const [chartStatus, setChartStatus] = useState('weekly')
    const [state, setState] = useState({
        data: props.data,
    })

    const changeChartData = (target) => {
        setChartStatus(target)
    }

    const data = {
        labels: state.data == null ? '' : state.data.chart[chartStatus].map(info => {
            return info.name
        }),
        datasets: [
            {
                label: 'کسب کرده',
                data: state.data == null ? '' : state.data.chart[chartStatus].map(info => {
                    return { x: info.name, y: info.earn }
                }),
                fill: false,
                backgroundColor: '#152b9f',
                borderColor: '#152b9f',
                tension: 0.4,
            },
            {
                label: 'خرج کرده',
                data: state.data == null ? '' : state.data.chart[chartStatus].map(info => {
                    return info.lose
                }),
                fill: false,
                backgroundColor: '#ff4337',
                borderColor: '#ff4337',
                tension: 0.4
            },
        ],
    };

    const options = {
        plugins: {
            legend: {
                display: false,
            },
        },
        scales: {
            x: {
                // display: false,
                grid: {
                    display: false,
                    rowHeight: 300
                }
            },
        }
    };

    const chartCmpnt = useMemo(() => {
        return <Line
            data={data}
            options={options}
        />
    }, [chartStatus])

    return (
        <div className="chart">
            <div className="row-btns">
                <div className={`btn-tiem ${chartStatus == 'weekly' ? 'active' : ''}`}>
                    <Button
                        variant="contained"
                        onClick={() => changeChartData('weekly')} >هفتگی</Button>
                </div>
                <div className={`btn-tiem ${chartStatus == 'monthly' ? 'active' : ''}`}>
                    <Button
                        variant="contained"
                        onClick={() => changeChartData('monthly')} >ماهانه</Button>
                </div>
                <div className={`btn-tiem ${chartStatus == 'annual' ? 'active' : ''}`}>
                    <Button
                        variant="contained"
                        onClick={() => changeChartData('annual')} >سالانه</Button>
                </div>
            </div>
            {state.data == null ? null :
                <div className="chart-scors">
                    {state.data.chart.annual.length == 0 &&
                        state.data.chart.monthly.length == 0 &&
                        state.data.chart.weekly.length == 0 ?
                        null
                        :
                        chartCmpnt
                    }
                </div>
            }

        </div>
    );
}

export default Chart;